module.exports = "/assets/72a6e1f61ed683deaa63ec873535aeb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/F9.png
// module id = 1362
// module chunks = 0